import React, { useContext, useEffect, useState } from 'react'
import Button from '../components/button'
import Top from '../components/top'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Users = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      user,
      setUser,
      isLogged,
      setIsLogged,
      login,
      logout
    } = useContext(AuthContext)

    const { users } = useContext(DetailsContext)
    
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])

    const inputs = [
        {
          name: "name",
          icon: 'fa-solid fa-cube',
          type: 'text',
          placeholder: 'Enter Name',
        },
        {
          name: "email",
          icon: 'fa-solid fa-user',
          type: 'email',
          placeholder: 'Enter Email',
        },
        {
          name: "phone",
          icon: 'fa-solid fa-user',
          type: 'tel',
          placeholder: 'Enter Phone Number'
        },
        {
          name: "date",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Date',
        },
        {
          name: "status",
          icon: 'fa-solid fa-user',
          type: 'select',
          vals: [
            {name: 'Verified', option:'verified'},
            {name: 'Unverified', option:'unverified'},
          ],
        }
      ]

    props.setNavShow(true)
    function formatNumber(number) {
      return number.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
      });
  }
    const userColumns = ['UserID', 'Username', 'Name', 'Phone', 'Profile', 'Password', 'Date Joined', 'Country', 'Gender', 'Email', 'Status']
    function addUsers(){
        window.location.replace('/edit')
    }
    const link = 'https://xgramm.com/xgramm_backend/admin/users.php'
  return (
    <div  style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={false} value='Add New Users' name='Users'/>
        <div className="w3-container">
        <Table tableName='users' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='All Users Details' columns={userColumns} data={users ? users : []} summary={false} edit={true} />
        </div>
    </div>
  )
}

export default Users